import React, { useEffect, useState, useRef, useMemo } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

//servicios
import { wsGet } from 'services/WService';
import { getPolygonPath } from 'services/PolygonPath';

//modal imports
import wkt from 'wkt';
import { wsFindBy, wsUpdate, wsGetAll } from 'services/WService';

import AddressModal from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Modal/Address/AddressModal';
import { WithApp } from 'contexts/appContext';
import useLayerContext from 'contexts/layerContext';
// Componentes
import ModalHeader from './ModalHeader';
import DialogDirecciones from './DialogDirecciones';
import { useStyles } from './useStyles';
import ModalToolbarInfo from './ModalToolbarInfo';
import ModalMap from './ModalMap';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default WithApp(function ModalMapRouteEdit(props) {
  const classes = useStyles();
  const showNotify = props.showNotify;

  const [openInfo, setOpenInfo] = useState(false);
  const [infoData, setInfoData] = useState({});
  const {
    layers,
    selectedLayer,
    setSelectedDivition,
    setSelectedLayer,
    filteredLayers,
  } = useLayerContext();

  const { showModal, setShowModal, routeId, setRouteId } = props;

  const handleClose = () => {
    setShowModal(false);
    setButtonUpdate(false);
    setRoute({});
    setAddresses([]);
    setRoutesRefference([]);
    setNewPolygon(null);
    setMapCenter(undefined);
    setRouteId(null);
    setDraggable({
      state: false,
      icon: '',
      idAddress: null,
    });
  };

  //#region  modal dentro del modal
  const [open, setOpen] = useState(false);

  const [geometryZone, setGeometryZone] = useState({});

  const handleClickOpen = () => {
    setOpen(true);
  };

  const eventClose = () => {
    setOpen(false);
  };
  //#endregion

  const [buttonUpdate, setButtonUpdate] = useState(false);

  const [route, setRoute] = useState({});
  const [stateFilter, setStateFilter] = useState('A');
  const [originalRoute, setOriginalRoute] = useState();
  const [poligonsHistory, setPoligonsHistory] = useState([]);
  const [routeHistory, setRouteHistory] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [selectedBureau, setSelectedBureau] = useState();
  const [showMarkerLabels, setShowMarkerLabels] = useState(false);

  const [draggable, setDraggable] = useState({}); //activar editar direccion
  const [newMarker, setNewMarker] = useState({ lat: 0, lng: 0 }); //activar editar direccion

  const [routesRefference, setRoutesRefference] = useState([]);
  const [mapRef, setMapRef] = useState(null);
  const routePolygon = useRef(null);
  const [newPolygon, setNewPolygon] = useState(null);
  const newPolygonRef = useRef(null);
  const [mapCenter, setMapCenter] = useState({
    lat: -14.836673004938541,
    lng: -74.9369324126855,
  });
  const [hoverDescription, setHoverDescription] = useState(null);

  const [showModalAddress, setShowModalAddress] = useState(false); //Abrir modal de direcciones
  const [objAddress, setObjAddress] = useState({}); // se llena de la direccion que seleccione para editar
  const [showAddresses, setShowAddresses] = useState(true);
  const [showOriginalGeometry, setShowOriginalGeometry] = useState(true);
  const [showReferenceRoutes, setShowReferenceRoutes] = useState(true);

  useEffect(() => {
    if (layers === undefined) return;
    if (route.base_layer_id === undefined) return;
    let selected = layers.find((layer) => layer.id === parseInt(route.base_layer_id));
    setSelectedDivition(selected.divition);
    setSelectedLayer(selected);
  }, [route.base_layer_id, layers]);

  const filteredRefferenceRoutes = useMemo(() => {
    if (selectedLayer === undefined) return routesRefference;
    if (selectedLayer.id === undefined) {
      let layerdIds = filteredLayers.map((layer) => layer.id);
      return routesRefference.filter((route) => layerdIds.includes(parseInt(route.base_layer_id)));
    }
    return routesRefference.filter((route) => parseInt(route.base_layer_id) === selectedLayer.id);
  }, [routesRefference, selectedLayer]);

  async function getRoute(bureauId = undefined) {
    let queryBureau = `&filter_type=${stateFilter}`;
    if (bureauId !== undefined) {
      queryBureau += '&base_bureau_id=' + bureauId;
    }
    let [response, responseAddreses] = await Promise.all([
      wsGet('base/route', routeId),
      wsGetAll(`base/route/${routeId}/addresses?with_bureaus=Y${queryBureau}`),
    ]);

    let zoneFirstPoint;
    if (response.data.zone.geometry !== null) {
      zoneFirstPoint = wkt.parse(response.data.zone.geometry).coordinates[0][0];
    }

    if (response.success) {
      let latLngMarker;
      if (responseAddreses.success) {
        if (responseAddreses.data.length > 0) {
          latLngMarker = responseAddreses.data.find((element) => {
            if (parseFloat(element.latitude) !== 0) {
              return parseFloat(element.latitude);
            }
            return undefined;
          });
        }
        setAddresses(responseAddreses.data);
        // setAddresses(responseAddreses.data.map(data => {
        //   return {...data, Address2: data.Address2.replace('MZ', 'Manzana')};
        // }));
      }

      if (!!responseAddreses.bureaus) {
        setBureaus(responseAddreses.bureaus);
      }

      if (response.data.geometry !== null) {
        response.data.geometry = wkt.parse(response.data.geometry).coordinates[0].map((point) => {
          return {
            lng: point[0],
            lat: point[1],
          };
        });
        response.data.geometry.pop();
        setMapCenter(response.data.geometry[0]);
      } else if (response.data.geometry === null && latLngMarker !== undefined) {
        setMapCenter({
          lat: parseFloat(latLngMarker.latitude),
          lng: parseFloat(latLngMarker.longitude),
        });
      } else {
        if (response.data.zone.latitude !== null && response.data.zone.longitude !== null) {
          setMapCenter({
            lat: response.data.zone.latitude,
            lng: response.data.zone.longitude,
          });
        } else {
          if (response.data.zone.geometry !== null) {
            setMapCenter({
              lat: zoneFirstPoint[1],
              lng: zoneFirstPoint[0],
            });
          }
        }
      }
      setRoute(response.data);
      setGeometryZone({
        lat: response.data.zone.latitude || zoneFirstPoint[1],
        lng: response.data.zone.longitude || zoneFirstPoint[0],
      });
      return response.data;
    }
  }

  async function getRoutesReference(route) {
    let response = await wsFindBy('base/route', 'base_zone_id', route.base_zone_id);
    if (response.success) {
      for (let i = 0; i < response.data.length; i++) {
        let row = response.data[i];
        if (!!row.geometry) {
          row.geometry = wkt.parse(row.geometry).coordinates[0].map((point) => {
            return {
              lng: point[0],
              lat: point[1],
            };
          });
        }
      }
      let currentRouteIndex = response.data.findIndex((r) => r.id == route.id);
      response.data.splice(currentRouteIndex, 1);
      setRoutesRefference(response.data);
    }
  }

  async function createPolygon() {
    if (route.geometry != null) {
      showNotify('ya existe un poígono', 'info');
      return;
    }
    if (newPolygon != null) {
      let coordinates = getPolygonPath(newPolygonRef.current);

      if (coordinates.length <= 4) {
        coordinates.push(coordinates[0]);
      }

      let wktString = wkt.stringify({
        type: 'Polygon',
        coordinates: [coordinates],
      });
      let response = await wsUpdate('base/route', route.id, {
        geometry: wktString,
      });
      if (response.success) {
        showNotify(response.message);
        setNewPolygon(null);
        setRoute({
          ...route,
          geometry: coordinates.map((point) => {
            return {
              lng: point[0],
              lat: point[1],
            };
          }),
        });
        props.reload();
      }
      return;
    }

    mapRef.setZoom(14);

    let newPolyZone = {
      paths: [
        {
          lat: geometryZone.lat,
          lng: geometryZone.lng,
        },
        {
          lat: geometryZone.lat,
          lng: geometryZone.lng + 0.005,
        },
        {
          lat: geometryZone.lat - 0.005,
          lng: geometryZone.lng + 0.005,
        },
        {
          lat: geometryZone.lat - 0.005,
          lng: geometryZone.lng,
        },
      ],
    };

    let newPolyMarker = {};
    if (addresses) {
      let getAddressPolygon = addresses.find(
        (item) => parseFloat(item.latitude) !== 0 && parseFloat(item.longitude) !== 0,
      );

      if (getAddressPolygon !== undefined) {
        newPolyMarker = {
          paths: [
            {
              lat: parseFloat(getAddressPolygon.latitude),
              lng: parseFloat(getAddressPolygon.longitude),
            },
            {
              lat: parseFloat(getAddressPolygon.latitude),
              lng: parseFloat(getAddressPolygon.longitude) + 0.005,
            },
            {
              lat: parseFloat(getAddressPolygon.latitude) - 0.005,
              lng: parseFloat(getAddressPolygon.longitude) + 0.005,
            },
            {
              lat: parseFloat(getAddressPolygon.latitude) - 0.005,
              lng: parseFloat(getAddressPolygon.longitude),
            },
          ],
        };

        let center = newPolyMarker.paths[0];
        setMapCenter(center);
      }
    }

    setNewPolygon(Object.keys(newPolyMarker).length === 0 ? newPolyZone : newPolyMarker);
    let center = newPolyZone.paths[0];
    setMapCenter(center);
  }

  async function updatePolygon() {
    let coordinates = getPolygonPath(routePolygon.current);

    if (coordinates === false) console.error('Error en PolygonPath.js');

    if (poligonsHistory.length > 0) {
      let index = poligonsHistory.findIndex(item => item.id === originalRoute.id);
      let dataRoutes = [...poligonsHistory];
      if(index !== -1){
        dataRoutes[index] = {
          ...originalRoute,
          geometry: coordinates.map((point) => ({ lat: point[1], lng: point[0] })),
        };
      } else {
        dataRoutes.push({
          ...originalRoute,
          geometry: coordinates.map((point) => ({ lat: point[1], lng: point[0] })),
        });
      }
      dataRoutes = dataRoutes.map(route => {
        return {
          id: route.id,
          points: route.geometry,
        };
      });
      
      setButtonUpdate(false);
      const response = await wsUpdate('base/route/update-multiple-poligons', {
        base_layer_id: selectedLayer.id,
        routes: dataRoutes,
      });

      if (response.success) {
        showNotify(response.message);
        if (!!props.reload) {
          props.reload();
        }
        setRouteHistory([]);
        setPoligonsHistory([]);
        setOriginalRoute(undefined);
        setButtonUpdate(false);
      } else {
        setButtonUpdate(true);
        showNotify(response.message, 'error');
      }

      return;
    }

    let wktString = wkt.stringify({
      type: 'Polygon',
      coordinates: [coordinates],
    });
    let response = await wsUpdate('base/route', route.id, {
      geometry: wktString,
    });
    if (response.success) {
      showNotify(response.message);
      if (!!props.reload) {
        props.reload();
      }
      setRouteHistory([]);
      setPoligonsHistory([]);
      setOriginalRoute(undefined);
      setButtonUpdate(false);
    } else {
      showNotify(response.message, 'error');
    }
  }

  function changeEditedPolygon(newPolygonRoute) {
    if(routePolygon.current === null) return;

    if (
      !window.confirm(
        `¿Seguro que quiere cambiar de poligono a editar?\nSe perderal el historial del poligono actual`,
      )
    ) {
      return;
    }

    let coordinates = getPolygonPath(routePolygon.current);

    if (coordinates === false) {
      console.error('Error en PolygonPath.js');
      return;
    }

    let originalRoute = route;
    // Agregar un poligono nuevo reemplazando el antiguo
    setRoute(newPolygonRoute);
    // Quitar poligonos ya existentes del listado y agregar la faltante
    let newRoutes = [...routesRefference];
    newRoutes = newRoutes.filter(r => r.id !== newPolygonRoute.id);
    // Agregando el poligono anterior al listado de referencias
    newRoutes.push({
      ...originalRoute,
      geometry: coordinates.map((point) => ({ lat: point[1], lng: point[0] })),
    });
    setRoutesRefference(newRoutes);

    // Agregando nueva variable de poligonos actualizados
    setPoligonsHistory((prev) => {
      let newPoligonsHistory = [...prev];
      let index = newPoligonsHistory.findIndex((i) => i.id === originalRoute.id);
      if (index === -1) {
        newPoligonsHistory.push({
          ...originalRoute,
          geometry: coordinates.map((point) => ({ lat: point[1], lng: point[0] })),
        });
      } else {
        newPoligonsHistory[index] = {
          ...originalRoute,
          geometry: coordinates.map((point) => ({ lat: point[1], lng: point[0] })),
        };
      }
      return newPoligonsHistory;
    });


    setOriginalRoute(newPolygonRoute);
    setRouteHistory([newPolygonRoute.geometry]);
    setButtonUpdate(true);
  }

  function onMouseUpEdit() {
    let newPath = getPolygonPath(routePolygon.current).map((point) => {
      return {
        lng: point[0],
        lat: point[1],
      };
    });

    newPath.pop();

    setRouteHistory([...routeHistory, newPath]);
    setRoute({ ...route, geometry: newPath });
  }

  async function getAddress() {
    let queryBureau = `&filter_type=${stateFilter}`;
    if (selectedBureau !== undefined) {
      queryBureau += '&base_bureau_id=' + selectedBureau.id;
    }
    let response = await wsGetAll(`base/route/${routeId}/addresses?with_bureaus=Y${queryBureau}`);
    if (response.success) setAddresses(response.data);
  }

  useEffect(() => {
    if (routeId != null) {
      getRoute(selectedBureau?.id).then((route) => {
        getRoutesReference(route);
      });
    }
  }, [routeId, selectedBureau, stateFilter]);

  return (
    <Dialog fullScreen open={showModal} onClose={handleClose} TransitionComponent={Transition}>
      <DialogDirecciones
        classes={classes}
        eventClose={eventClose}
        open={open}
        selectedBureau={selectedBureau}
        addresses={addresses}
        setShowModalAddress={setShowModalAddress}
        setObjAddress={setObjAddress}
        setOpenInfo={setOpenInfo}
        setInfoData={setInfoData}
      />

      {showModalAddress == true ? (
        <AddressModal
          open={showModalAddress}
          setOpen={setShowModalAddress}
          addressId={objAddress.id}
          bPartner={objAddress.base_business_partner_id}
          disabled
          reload={getAddress}
          showNotify={showNotify}
          layers={layers}
        />
      ) : undefined}

      <GridContainer style={{ width: 'calc(100% + 0px)', margin: '0' }}>
        <ModalHeader classes={classes} handleClose={handleClose} />
        <GridItem xs={12} sm={12} className={classes.grid}>
          <ModalToolbarInfo
            classes={classes}
            showNotify={showNotify}
            routePolygon={routePolygon}
            setRouteHistory={setRouteHistory}
            setRoute={setRoute}
            originalRoute={originalRoute}
            setOriginalRoute={setOriginalRoute}
            setButtonUpdate={setButtonUpdate}
            route={route}
            addresses={addresses}
            handleClickOpen={handleClickOpen}
            hoverDescription={hoverDescription}
            buttonUpdate={buttonUpdate}
            updatePolygon={updatePolygon}
            routeHistory={routeHistory}
            showAddresses={showAddresses}
            setShowAddresses={setShowAddresses}
            showOriginalGeometry={showOriginalGeometry}
            setShowOriginalGeometry={setShowOriginalGeometry}
            showReferenceRoutes={showReferenceRoutes}
            setShowReferenceRoutes={setShowReferenceRoutes}
            createPolygon={createPolygon}
            newPolygon={newPolygon}
            bureaus={bureaus}
            selectedBureau={selectedBureau}
            setSelectedBureau={setSelectedBureau}
            stateFilter={stateFilter}
            setStateFilter={setStateFilter}
            layers={layers}
            showMarkerLabels={showMarkerLabels}
            setShowMarkerLabels={setShowMarkerLabels}
          />

          <ModalMap
            mapRef={mapRef}
            showNotify={showNotify}
            getAddress={getAddress}
            setMapRef={setMapRef}
            mapCenter={mapCenter}
            setMapCenter={setMapCenter}
            newPolygonRef={newPolygonRef}
            newPolygon={newPolygon}
            showAddresses={showAddresses}
            addresses={addresses}
            showMarkerLabels={showMarkerLabels}
            draggable={draggable}
            newMarker={newMarker}
            setNewMarker={setNewMarker}
            setDraggable={setDraggable}
            onMouseUpEdit={onMouseUpEdit}
            buttonUpdate={buttonUpdate}
            routePolygon={routePolygon}
            route={route}
            showReferenceRoutes={showReferenceRoutes}
            filteredRefferenceRoutes={filteredRefferenceRoutes}
            setHoverDescription={setHoverDescription}
            showOriginalGeometry={showOriginalGeometry}
            originalRoute={originalRoute}
            openInfo={openInfo}
            infoData={infoData}
            setOpenInfo={setOpenInfo}
            setInfoData={setInfoData}
            classes={classes}
            changeEditedPolygon={changeEditedPolygon}
          />
        </GridItem>
      </GridContainer>
    </Dialog>
  );
});
